var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDownRebranding = function SvgChevronDownRebranding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.77 9.36 3.464 4.156a1 1 0 0 0 1.537 0l3.463-4.156 1.537 1.28-3.464 4.156a3 3 0 0 1-4.61 0L6.235 10.64z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDownRebranding;